
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"235","height":"326","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1086_7285)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.102 170.507a13.824 13.824 0 0011.61 6.3H97.09l-64.86 162.4c-.756 6.477.12 13.856 6.29 17.157 2.073 1.105 5.48 1.636 6.53 1.636 4.386 0 8.672-2.079 11.336-5.877l166.137-236.381c2.937-4.774 3.291-10.247.913-14.779a13.817 13.817 0 00-12.241-7.377h-42.723l32.89-73.266a13.657 13.657 0 00-1.027-13.065A13.821 13.821 0 00188.754 1h-66.742c-5.735 0-10.648 3.14-12.891 8.035L41.148 157.606c-1.945 4.033-1.589 8.975.954 12.901z","fill":"#F6E94A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1086_7285"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h235v326H0z"}})])])])
          )
        }
      }
    